import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './stylesheet/App.scss'
import './stylesheet/fonts.scss'
import './stylesheet/NavBar.scss'
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers'

const store = createStore(reducers, compose(applyMiddleware(thunk)));

ReactDOM.render(
<Provider store ={store}><App /></Provider>, document.getElementById('root'));